import { render, staticRenderFns } from "./TaxSession.vue?vue&type=template&id=4158fff3&scoped=true"
import script from "./TaxSession.vue?vue&type=script&lang=js"
export * from "./TaxSession.vue?vue&type=script&lang=js"
import style0 from "./TaxSession.vue?vue&type=style&index=0&id=4158fff3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158fff3",
  null
  
)

export default component.exports